module.exports = __webpack_public_path__ + "static/media/productos.0873c997.jsonl";